var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":_vm.title,"placement":"top","visible-arrow":true}},[_c('i',{staticClass:"ico",on:{"click":_vm.clickSend}})])}
var staticRenderFns = []

export { render, staticRenderFns }